export default __webpack_public_path__ + "3b7e6919f24245b442a7fce8b0b509bd.png";